import { unref as _unref, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "fixed inset-0 z-30 overflow-y-auto p-4 sm:p-6 md:p-20" }
const _hoisted_2 = { class: "relative" }
const _hoisted_3 = { class: "pointer-events-none absolute top-3 right-4 text-gray-500 bg-gray-200 rounded px-1" }
const _hoisted_4 = { class: "flex items-center justify-between bg-gray-100 py-2.5 px-4 text-xs font-semibold text-gray-900" }
const _hoisted_5 = ["disabled"]
const _hoisted_6 = { class: "mt-2 text-sm text-gray-800" }
const _hoisted_7 = { class: "bg-gray-100 py-2.5 px-4 text-xs font-semibold text-gray-900" }
const _hoisted_8 = { class: "mt-2 text-sm text-gray-800" }
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "bg-gray-100 py-2.5 px-4 text-xs font-semibold text-gray-900" }
const _hoisted_11 = { class: "mt-2 text-sm text-gray-800" }
const _hoisted_12 = ["src"]
const _hoisted_13 = { class: "bg-gray-100 py-2.5 px-4 text-xs font-semibold text-gray-900" }
const _hoisted_14 = { class: "mt-2 text-sm text-gray-800" }
const _hoisted_15 = { class: "bg-gray-100 py-2.5 px-4 text-xs font-semibold text-gray-900" }
const _hoisted_16 = { class: "mt-2 text-sm text-gray-800" }
const _hoisted_17 = { class: "bg-gray-100 py-2.5 px-4 text-xs font-semibold text-gray-900" }
const _hoisted_18 = { class: "mt-2 text-sm text-gray-800" }
const _hoisted_19 = { class: "bg-gray-100 py-2.5 px-4 text-xs font-semibold text-gray-900" }
const _hoisted_20 = { class: "mt-2 text-sm text-gray-800" }
const _hoisted_21 = { class: "bg-gray-100 py-2.5 px-4 text-xs font-semibold text-gray-900" }
const _hoisted_22 = { class: "mt-2 text-sm text-gray-800" }
const _hoisted_23 = { class: "border-t border-gray-100 py-14 px-6 text-center text-sm sm:px-14" }

import {
  Combobox,
  ComboboxInput,
  ComboboxOption,
  ComboboxOptions,
  Dialog,
  DialogPanel,
  TransitionChild,
  TransitionRoot
} from '@headlessui/vue'
import { ClipboardDocumentListIcon, MagnifyingGlassIcon } from '@heroicons/vue/20/solid'
import { computed, onMounted, onUnmounted, ref } from 'vue'
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'

import { usePagedSearch } from '@/composables/usePagedSearch'
import { formatPhone } from '@/helpers/phone'
import api from '@/store/api'
import { mapRelationships } from '@/store/mappers'

import BasicSpinner from './BasicSpinner.vue'


export default {
  __name: 'OmniSearch',
  setup(__props) {

const store = useStore()
const router = useRouter()

// use client hints if available, fall back to deprecated navigator.platform if not
const isMac = computed(() =>
  navigator.userAgentData ? navigator.userAgentData.platform === 'macOS' : navigator.platform === 'MacIntel'
)

const keyHandler = e => {
  if (e.key === 'k' && (isMac.value ? e.metaKey : e.ctrlKey)) {
    e.preventDefault()
    store.commit('TOGGLE_OMNI')
  }
}

onMounted(() => document.addEventListener('keydown', keyHandler))
onUnmounted(() => document.removeEventListener('keydown', keyHandler))

const query = ref('')
const results = ref({})
const controllers = {}
const pending = ref({})
const timers = {}
let searchAllTimer

const contactSearch = usePagedSearch({
  endpoint: 'conversation_user_pairs/search',
  shape: x => ({
    name: x.attributes.display_name,
    phone: x.attributes.phone ?? '',
    url: `/messages/${x.id}`,
    reload: false
  })
})
const { hasMore: hasMoreContacts, loadingMore: loadingMoreContacts } = contactSearch

const ignoreAbort = e => {
  if (e.name !== 'AbortError') throw e
}

const showResults = (type, fetchResults) => {
  clearTimeout(timers[type])
  timers[type] = setTimeout(() => {
    pending.value[type] = true
    results.value[type] = []
  }, 350)

  return fetchResults()
    .then(found => {
      results.value[type] = found

      clearTimeout(timers[type])
      pending.value[type] = false
    })
    .catch(ignoreAbort)
}

const search = (type, shape) =>
  showResults(type, () => {
    controllers[type]?.abort()
    controllers[type] = new AbortController()

    return api
      .call(
        'POST',
        `${type}/search`,
        { search: { text: query.value } },
        { save: false, abortController: controllers[type] }
      )
      .then(x => x.data.data.map(shape))
  })

const searchContacts = () => showResults('contacts', () => contactSearch.search(query.value))

const loadMoreContacts = () =>
  contactSearch
    .loadMore()
    .then(found => results.value.contacts.push(...found))
    .catch(ignoreAbort)

const runSearchAll = () => {
  if (!query.value) {
    results.value = {}
    pending.value = {}
    contactSearch.reset()
    Object.values(controllers).forEach(x => x.abort())
    Object.values(timers).forEach(x => clearTimeout(x))
    return
  }

  searchContacts()

  search('products', x => ({
    name: x.attributes.product_name,
    image: mapRelationships(x.relationships.attachments.data)[0]?.attributes.secure_url,
    url: `/store/products/${x.id}`,
    reload: true
  }))

  search('stores', x => ({
    name: x.attributes.store_name,
    image: mapRelationships(x.relationships.attachments.data)[0]?.attributes.secure_url,
    url: `/store/stores/${x.id}`,
    reload: true
  }))

  search('bottles', x => ({
    name: x.attributes.display_id,
    url: `/order/${x.id}`,
    reload: true
  }))

  search('bottle_cycles', x => ({
    name: x.attributes.description,
    url: `/store/drops/${x.id}`,
    reload: true
  }))

  search('discount_codes', x => ({
    name: x.attributes.discount_code_name,
    code: x.attributes.code,
    url: `/store/discount-codes/${x.id}`,
    reload: true
  }))

  search('fulfillment_methods', x => ({
    name: x.attributes.name,
    description: x.attributes.description,
    url: `/store/fulfillment-methods/${x.id}`,
    reload: true
  }))

  search('audiences', x => ({
    name: x.attributes.audience_name,
    url: `/lists/${x.id}`,
    reload: true
  }))
}

const searchAll = () => {
  clearTimeout(searchAllTimer)
  searchAllTimer = setTimeout(() => {
    runSearchAll()
  }, 500)
}

const goToItem = ({ url, reload }) => {
  store.commit('TOGGLE_OMNI')
  // router.go() refreshes the page after we change the URL
  // since right now some components don't cope well with getting a different ID without reload
  router.push(url).then(() => reload && router.go())
}

let lastClose = new Date()
const close = () => {
  // for some reason on mobile this event gets fired twice
  if (lastClose > new Date() - 200) return
  lastClose = new Date()
  store.commit('TOGGLE_OMNI')
}

return (_ctx, _cache) => {
  return (_openBlock(), _createBlock(_unref(TransitionRoot), {
    show: _unref(store).state.omniSearchOpen,
    as: "template"
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(Dialog), {
        class: "relative z-20",
        role: "dialog",
        "aria-modal": "true",
        onClose: close
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(TransitionChild), {
            enter: "ease-out duration-300",
            "enter-from": "opacity-0",
            "enter-to": "opacity-100",
            leave: "ease-in duration-200",
            "leave-from": "opacity-100",
            "leave-to": "opacity-0"
          }, {
            default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
              _createElementVNode("div", {
                class: "fixed inset-0 bg-gray-500 bg-opacity-50 transition-opacity",
                "aria-hidden": "true"
              }, null, -1)
            ]))]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_unref(TransitionChild), {
              enter: "ease-out duration-300",
              "enter-from": "opacity-0 scale-95",
              "enter-to": "opacity-100 scale-100",
              leave: "ease-in duration-200",
              "leave-from": "opacity-100 scale-100",
              "leave-to": "opacity-0 scale-95"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(DialogPanel), { class: "mx-auto max-w-xl transform overflow-hidden rounded-xl bg-white shadow-2xl ring-1 ring-black ring-opacity-5 transition-all" }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(Combobox), {
                      as: "div",
                      "onUpdate:modelValue": goToItem
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_2, [
                          _withDirectives(_createVNode(_unref(MagnifyingGlassIcon), {
                            class: "pointer-events-none absolute top-3.5 left-4 h-5 w-5 text-gray-400",
                            "aria-hidden": "true"
                          }, null, 512), [
                            [_vShow, !Object.values(pending.value).some(x => x)]
                          ]),
                          _withDirectives(_createVNode(BasicSpinner, {
                            class: "pointer-events-none absolute top-3.5 left-4 h-5 w-5",
                            color: "black",
                            "aria-hidden": "true"
                          }, null, 512), [
                            [_vShow, Object.values(pending.value).some(x => x)]
                          ]),
                          _createVNode(_unref(ComboboxInput), {
                            class: "h-12 w-full border-0 bg-transparent pl-11 pr-4 text-gray-800 placeholder-gray-400 focus:ring-0 sm:text-sm",
                            autocomplete: "off",
                            placeholder: "Search everything...",
                            onChange: _cache[0] || (_cache[0] = 
                    e => {
                      query.value = e.target.value
                      searchAll()
                    }
                  )
                          }),
                          _createElementVNode("span", _hoisted_3, _toDisplayString(isMac.value ? '⌘K' : 'Ctrl K'), 1)
                        ]),
                        _withDirectives(_createVNode(_unref(ComboboxOptions), {
                          id: "options",
                          class: "max-h-80 scroll-pt-11 scroll-pb-2 space-y-2 overflow-y-auto pb-2",
                          role: "listbox"
                        }, {
                          default: _withCtx(() => [
                            _withDirectives(_createElementVNode("h2", _hoisted_4, [
                              _cache[3] || (_cache[3] = _createTextVNode(" Contacts ", -1)),
                              (_unref(hasMoreContacts))
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 0,
                                    type: "button",
                                    class: "text-brand-600 hover:text-brand-700 focus:outline-none disabled:opacity-50",
                                    disabled: _unref(loadingMoreContacts),
                                    onMousedown: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["prevent"])),
                                    onClick: loadMoreContacts
                                  }, " More ", 40, _hoisted_5))
                                : _createCommentVNode("", true)
                            ], 512), [
                              [_vShow, results.value.contacts?.length]
                            ]),
                            _createElementVNode("ul", _hoisted_6, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(results.value.contacts, (x) => {
                                return (_openBlock(), _createBlock(_unref(ComboboxOption), {
                                  key: x.url,
                                  as: "template",
                                  value: x
                                }, {
                                  default: _withCtx(({ active }) => [
                                    _createElementVNode("li", {
                                      class: _normalizeClass(['cursor-pointer select-none px-4 py-2', active && 'bg-brand-600 text-white'])
                                    }, [
                                      _createTextVNode(_toDisplayString(x.name) + " ", 1),
                                      _createElementVNode("span", {
                                        class: _normalizeClass(["text-gray-500 ml-2", active && 'text-gray-300'])
                                      }, _toDisplayString(_unref(formatPhone)(x.phone)), 3)
                                    ], 2)
                                  ]),
                                  _: 2
                                }, 1032, ["value"]))
                              }), 128))
                            ]),
                            _withDirectives(_createElementVNode("h2", _hoisted_7, " Products ", 512), [
                              [_vShow, results.value.products?.length]
                            ]),
                            _createElementVNode("ul", _hoisted_8, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(results.value.products, (x) => {
                                return (_openBlock(), _createBlock(_unref(ComboboxOption), {
                                  as: "template",
                                  value: x
                                }, {
                                  default: _withCtx(({ active }) => [
                                    _createElementVNode("li", {
                                      class: _normalizeClass(['cursor-pointer select-none px-4 py-2', active && 'bg-brand-600 text-white'])
                                    }, [
                                      _withDirectives(_createElementVNode("img", {
                                        class: "aspect-square h-8 w-8 rounded select-none inline mr-2",
                                        src: x.image
                                      }, null, 8, _hoisted_9), [
                                        [_vShow, x.image]
                                      ]),
                                      _createTextVNode(" " + _toDisplayString(x.name), 1)
                                    ], 2)
                                  ]),
                                  _: 2
                                }, 1032, ["value"]))
                              }), 256))
                            ]),
                            _withDirectives(_createElementVNode("h2", _hoisted_10, " Stores ", 512), [
                              [_vShow, results.value.stores?.length]
                            ]),
                            _createElementVNode("ul", _hoisted_11, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(results.value.stores, (x) => {
                                return (_openBlock(), _createBlock(_unref(ComboboxOption), {
                                  as: "template",
                                  value: x
                                }, {
                                  default: _withCtx(({ active }) => [
                                    _createElementVNode("li", {
                                      class: _normalizeClass(['cursor-pointer select-none px-4 py-2', active && 'bg-brand-600 text-white'])
                                    }, [
                                      _withDirectives(_createElementVNode("img", {
                                        class: "aspect-square h-8 w-8 rounded select-none inline mr-2",
                                        src: x.image
                                      }, null, 8, _hoisted_12), [
                                        [_vShow, x.image]
                                      ]),
                                      _createTextVNode(" " + _toDisplayString(x.name), 1)
                                    ], 2)
                                  ]),
                                  _: 2
                                }, 1032, ["value"]))
                              }), 256))
                            ]),
                            _withDirectives(_createElementVNode("h2", _hoisted_13, " Orders ", 512), [
                              [_vShow, results.value.bottles?.length]
                            ]),
                            _createElementVNode("ul", _hoisted_14, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(results.value.bottles, (x) => {
                                return (_openBlock(), _createBlock(_unref(ComboboxOption), {
                                  as: "template",
                                  value: x
                                }, {
                                  default: _withCtx(({ active }) => [
                                    _createElementVNode("li", {
                                      class: _normalizeClass(['cursor-pointer select-none px-4 py-2', active && 'bg-brand-600 text-white'])
                                    }, _toDisplayString(x.name), 3)
                                  ]),
                                  _: 2
                                }, 1032, ["value"]))
                              }), 256))
                            ]),
                            _withDirectives(_createElementVNode("h2", _hoisted_15, " Drops ", 512), [
                              [_vShow, results.value.bottle_cycles?.length]
                            ]),
                            _createElementVNode("ul", _hoisted_16, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(results.value.bottle_cycles, (x) => {
                                return (_openBlock(), _createBlock(_unref(ComboboxOption), {
                                  as: "template",
                                  value: x
                                }, {
                                  default: _withCtx(({ active }) => [
                                    _createElementVNode("li", {
                                      class: _normalizeClass(['cursor-pointer select-none px-4 py-2', active && 'bg-brand-600 text-white'])
                                    }, _toDisplayString(x.name), 3)
                                  ]),
                                  _: 2
                                }, 1032, ["value"]))
                              }), 256))
                            ]),
                            _withDirectives(_createElementVNode("h2", _hoisted_17, " Discount codes ", 512), [
                              [_vShow, results.value.discount_codes?.length]
                            ]),
                            _createElementVNode("ul", _hoisted_18, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(results.value.discount_codes, (x) => {
                                return (_openBlock(), _createBlock(_unref(ComboboxOption), {
                                  as: "template",
                                  value: x
                                }, {
                                  default: _withCtx(({ active }) => [
                                    _createElementVNode("li", {
                                      class: _normalizeClass(['cursor-pointer select-none px-4 py-2', active && 'bg-brand-600 text-white'])
                                    }, [
                                      _createTextVNode(_toDisplayString(x.name) + " ", 1),
                                      _createElementVNode("span", {
                                        class: _normalizeClass(["text-gray-500 ml-2", active && 'text-gray-300'])
                                      }, _toDisplayString(x.code), 3)
                                    ], 2)
                                  ]),
                                  _: 2
                                }, 1032, ["value"]))
                              }), 256))
                            ]),
                            _withDirectives(_createElementVNode("h2", _hoisted_19, " Fulfillment methods ", 512), [
                              [_vShow, results.value.fulfillment_methods?.length]
                            ]),
                            _createElementVNode("ul", _hoisted_20, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(results.value.fulfillment_methods, (x) => {
                                return (_openBlock(), _createBlock(_unref(ComboboxOption), {
                                  as: "template",
                                  value: x
                                }, {
                                  default: _withCtx(({ active }) => [
                                    _createElementVNode("li", {
                                      class: _normalizeClass(['cursor-pointer select-none px-4 py-2', active && 'bg-brand-600 text-white'])
                                    }, [
                                      _createTextVNode(_toDisplayString(x.name) + " ", 1),
                                      _createElementVNode("span", {
                                        class: _normalizeClass(["text-gray-500 ml-2", active && 'text-gray-300'])
                                      }, _toDisplayString(x.description.slice(0, 50)) + _toDisplayString(x.description.length > 50 ? '...' : ''), 3)
                                    ], 2)
                                  ]),
                                  _: 2
                                }, 1032, ["value"]))
                              }), 256))
                            ]),
                            _withDirectives(_createElementVNode("h2", _hoisted_21, " Groups ", 512), [
                              [_vShow, results.value.audiences?.length]
                            ]),
                            _createElementVNode("ul", _hoisted_22, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(results.value.audiences, (x) => {
                                return (_openBlock(), _createBlock(_unref(ComboboxOption), {
                                  as: "template",
                                  value: x
                                }, {
                                  default: _withCtx(({ active }) => [
                                    _createElementVNode("li", {
                                      class: _normalizeClass(['cursor-pointer select-none px-4 py-2', active && 'bg-brand-600 text-white'])
                                    }, _toDisplayString(x.name), 3)
                                  ]),
                                  _: 2
                                }, 1032, ["value"]))
                              }), 256))
                            ])
                          ]),
                          _: 1
                        }, 512), [
                          [_vShow, query.value.length && Object.values(results.value).flat().length]
                        ]),
                        _withDirectives(_createElementVNode("div", _hoisted_23, [
                          _createVNode(_unref(ClipboardDocumentListIcon), { class: "mx-auto h-6 w-6 text-gray-400" }),
                          _cache[4] || (_cache[4] = _createElementVNode("p", { class: "mt-2 text-gray-500" }, "No results found using that search term.", -1))
                        ], 512), [
                          [_vShow, query.value.length && !Object.values(results.value).flat().length]
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["show"]))
}
}

}